import { Compass, Handshake, Home } from "lucide-react";

const GROUPS = [
  { key: "educators", icon: Compass, title: "Educators, facilitators and changemakers",
    text: "Deepen your practice, find peers who share your values, and bring whole-person learning into your own work.", accent: "bg-bloom" },
  { key: "partners", icon: Handshake, title: "Organisations, funders and partners",
    text: "Walk alongside an ecology that joins learning, healing and contribution. We would love to explore partnering with you.", accent: "bg-plum" },
  { key: "families", icon: Home, title: "Families and young people",
    text: "A place for curiosity, care and belonging, where young people and their families can grow together.", accent: "bg-gold" },
];

export const Audience = () => (
  <section id="who" className="bg-primary py-28 text-primary-foreground lg:py-36" data-testid="audience-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Who it's for</p>
      <h2 className="mt-6 max-w-3xl font-display text-4xl font-bold leading-tight tracking-tight sm:text-5xl">
        A village of learners, healers and <span className="text-gold">contributors.</span>
      </h2>
      <div className="mt-20 divide-y divide-primary-foreground/15 border-y border-primary-foreground/15">
        {GROUPS.map((g) => (
          <div key={g.key} className="group grid gap-6 py-10 md:grid-cols-12 md:items-center" data-testid={`audience-${g.key}`}>
            <div className="flex items-center gap-5 md:col-span-6">
              <span className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-sm ${g.accent} transition-transform duration-300 group-hover:scale-110`}>
                <g.icon className="h-6 w-6 text-white" strokeWidth={1.5} />
              </span>
              <h3 className="font-display text-2xl font-bold sm:text-3xl">{g.title}</h3>
            </div>
            <p className="text-base leading-relaxed text-primary-foreground/80 md:col-span-6">{g.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
